"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_NOT_FOUND = exports.NOT_FOUND = exports.INVALID_DOMAIN_FOR_LINK = exports.BOOKING_TIME_CONFLICT = void 0;
var BOOKING_TIME_CONFLICT = 'meeting booked from underneath';
exports.BOOKING_TIME_CONFLICT = BOOKING_TIME_CONFLICT;
var INVALID_DOMAIN_FOR_LINK = 'INVALID_DOMAIN_FOR_LINK';
exports.INVALID_DOMAIN_FOR_LINK = INVALID_DOMAIN_FOR_LINK;
var NOT_FOUND = 'Link not found';
exports.NOT_FOUND = NOT_FOUND;
var USER_NOT_FOUND = 'User not found';
exports.USER_NOT_FOUND = USER_NOT_FOUND;